export const standardColours = {
  black: '#000',
  darkGrey: '#0A0E06',
  grey: '#C6C6C6',
  lightGrey: '#F6F9F1',
  white: '#FFF',
  transparentBlack: value => {
    return `rgba(0, 0, 0, ${value})`;
  },
  transparentWhite: value => {
    return `rgba(255, 255, 255, ${value})`;
  },
  transparent: 'rgba(255, 255, 255, 0)',
};

export const brandColours = {
  primary: '#A0DA0E', // green
  secondary: '#6FCF0E', // dark green
  tertiary: '#0ECFCF', // turquoise
  quaternary: '#212F17', // darker green
  quinary: '#f5f9f1', // lightest green
  senary: '#D7F8EB', // light green
  septenary: '#354E5A', // dark turquoise
  octonary: '#EBF0E3', // lighter green
};

export const elementColours = {
  textColour: brandColours.quaternary,
};
